import React, {useEffect, useRef} from 'react';
import mainStyles from 'components/homeParallax/HomeParallax.module.scss';
import styles from './Products.module.scss'
import macroStyles from "components/homePanels/f-i_macroPage/MacroPage.module.scss";
import Splitting from 'splitting';
import {gsap, TimelineMax, TweenMax} from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger'
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import ScrollMagic from "scrollmagic";
import layerStyles from "components/homePanels/f-i_macroPage/heroLayers/Layers.module.scss";
import SpinningProduct from "components/homePanels/f-i_macroPage/products/spinningProduct/SpinningProduct";
gsap.registerPlugin(ScrollTrigger);


const Products = (props) => {

    const trigger = useRef();
    const title = useRef();
    const subTitle = useRef();

    const prodTitle = useRef([]);
    const prodImage = useRef([]);
    const prodDesc = useRef([]);
    const prodLink = useRef([]);


    useEffect(()=>{

        let timeout = setTimeout(()=>{

            let controller = new ScrollMagic.Controller({
                container: props.scroller
            });

            let timeline = new TimelineMax();
            let elements = [];

            let titleText = TweenMax.fromTo(title.current, { opacity: 0, top: 50}, {opacity: 1, top: 0, delay: 1, duration: 5 });
            elements.push(titleText);

            let subTitleText = TweenMax.fromTo(subTitle.current,  { opacity: 0, top: 50}, { opacity: 1, top: 0, delay: 2, duration: 5 });
            elements.push(subTitleText);

            prodImage.current.forEach((ref,refIndex)=>{

                /** double start if second instance and mobile **/
                let delay = (window.innerWidth <= 768 && refIndex === 1) ? 21 : 15;

                let newImage = TweenMax.fromTo(ref, { scale: 0}, { scale: 1, delay: delay, duration: 5 });
                elements.push(newImage);
            })

            prodTitle.current.forEach((ref,refIndex)=>{

                /** double start if second instance and mobile **/
                let delay = (window.innerWidth <= 768 && refIndex === 1) ? 23 : 17;

                let prodTitleText = TweenMax.fromTo(ref, { opacity: 0, top: 50 }, { opacity: 1, top: 0, delay: delay, duration: 5  });
                elements.push(prodTitleText);
            })

            prodDesc.current.forEach((ref, refIndex)=>{

                let lines = Splitting({target: ref, by: 'lines'});

                /** double start if second instance and mobile **/
                let delay = (window.innerWidth <= 768 && refIndex === 1) ? 25 : 19;

                if (lines && lines[0]) lines[0].lines.forEach((line) => {
                    line.forEach((item) => {
                        let line = TweenMax.fromTo(item, 6,{ opacity: 0, top: 50 }, { opacity: 1, top: 0, delay: delay, duration: 5 });
                        elements.push(line);
                    })
                    delay = delay + .75;

                })

            })

            prodLink.current.forEach((ref,refIndex)=>{

                /** double start if second instance and mobile **/
                let delay = (window.innerWidth <= 768 && refIndex === 1) ? 29 : 23;

                let disclaimerText = TweenMax.fromTo(ref, { opacity: 0, top: 50 }, { opacity: 1, top: 0, delay: delay, duration: 5  });
                elements.push(disclaimerText);
            })

            timeline.add(elements);

            new ScrollMagic.Scene({
                reverse: true,
                triggerElement: trigger.current,
                triggerHook: 'onEnter',
                duration: '100%'})
                .setTween(elements)
                .addTo(controller);

        }, 200)

        return ()=>clearTimeout(timeout)

    },[props.scroller])

    function externalIcon (){
        return (props.macro === 'martellus' || props.macro === 'cache') ? 'https://msobd-storage.azureedge.net/images/external-icon-black.png' : 'https://msobd-storage.azureedge.net/images/external-icon.png';
    }

    function buildProductDisplays(){
        return props.products.products.map((product, productIndex)=>{
            return (
                <div key={productIndex} className={styles.product}>
                    <SpinningProduct title={product.title} src={product.image} animation={product.animation} scroller={props.scroller}/>
                    <h5 ref={el => prodTitle.current[productIndex] = el}>{product.title}</h5>

                    <p className={mainStyles.accessibleContent} dangerouslySetInnerHTML={{__html:product.description}}/>
                    {product.disclaimer && <p className={mainStyles.accessibleContent}
                        dangerouslySetInnerHTML={{__html: product.description}}/>}
                    <span className={styles.description} aria-hidden={true}>
                        <p ref={el => prodDesc.current[productIndex] = el} dangerouslySetInnerHTML={{__html:product.description}}/>
                    </span>

                    <a ref={el => prodLink.current[productIndex] = el} href={product.linkUrl} target={'_blank'} rel="noreferrer">
                        <span className={styles.link}>{product.linkText}</span>
                        <img className={styles.external} src={externalIcon()} alt={'External link'}/>
                    </a>
                </div>
            )
        })

    }

    function buildBgLayers(){


        if(props.macro === 'martellus'){
            return (
                <>
                    <div aria-hidden={true} className={layerStyles.martellus_productsCloudRight}>
                        <ImageWrapper set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-content-right-flower-clouds.jpg'}} alt={'Flower Cloud Right'}/>
                    </div>

                </>
            )
        }
    }

    return (
        <div className={`${macroStyles.macroPanel} ${styles.products}`}>
            {buildBgLayers()}
            <div className={styles.trigger} ref={trigger}/>
            <h4 ref={title} className={styles.title} dangerouslySetInnerHTML={{__html:props.products.title}}/>
            <div ref={subTitle} className={styles.subTitle}>{props.products.subTitle}</div>
            <div className={styles.productWrapper}>
                {buildProductDisplays()}
            </div>

        </div>
    )
};

export default Products
